import React from 'react';
import SingleLineText from './SingleLineText';
import { settingsSheetTitle } from '../../design/tokens';

export default function SettingsSheetTitle({ sx, ...props }) {
    return <SingleLineText {...props} data-settings-sheet-title="true"
        sx={[{ mb: 1 }, ...(Array.isArray(sx) ? sx : [sx]), settingsSheetTitle]} />;
}
